<template>
  <element>
    <AppBar :title="$t('collectionListPage.title')" />
    <v-container>
      <h3 class="category-label">{{ $t('collectionListPage.title') }}</h3>
      <CollectionCard
        v-for="collection in collection_list"
        :key="collection.id"
        :name="collection.name"
        :inventory="collection.inventory"
        :shelf="collection.shelf"
        :room="collection.room"
        :quantity="collection.quantity"
        :found="collection.found"
        :img_url="collection.img_url"
      />
      <h3 class="category-label">{{ $t('collectionListPage.subtitle') }}</h3>
      <v-row no-gutters>
        <v-select
          v-model="collection_status"
          :items="items"
          background-color="rgba(224, 231, 255, 0.2)"
          outlined
          dense
          light
        >
      </v-select>
      </v-row>
      <v-row no-gutters>
        <v-col class="mr-1">
          <v-btn color="#033e8c" dark block>{{ $t('collectionListPage.button-1') }}</v-btn>
        </v-col>
        <v-col class="ml-1">
          <v-btn color="#033e8c" dark block>{{ $t('collectionListPage.button-2') }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import CollectionCard from "@/components/collection/CollectionCard.vue";

export default {
  name: "CollectionListPage",
  components: {
    AppBar,
    CollectionCard,
  },
  props: {
    status: String,
  },
  data () {
    return {
      collection_status: this.status,
      items: ['Ready', 'In progress', 'Sold'],
      collection_list: [
        {
          id: 0,
          name: "Side mount",
          inventory: 7,
          shelf: 6,
          room: "A",
          quantity: 2,
          found: false,
          img_url: "/img/side-mount-intercooler.jpg",
        },
        {
          id: 1,
          name: "Short block",
          inventory: 7,
          shelf: 3,
          room: "C",
          quantity: 1,
          found: true,
          img_url: "/img/IMG_20181113_105642_1024x1024.jpg",
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>